export default __webpack_public_path__ + "static/media/gallery-11-4.07eebde7.webp";